import { createI18n, useI18n } from "vue-i18n";
import { useApp } from "@/application/composables/app";
import { nl } from "vuetify/locale";
import deepMerge from "@/application/utils/deepMerge";
import { CurrencyType } from "@/application/enums";

const { appIdentifier } = useApp();

const messages: Record<string, Record<string, any>> = {};

const translations = import.meta.glob<string>("@/**/translations/*.yaml", {
  eager: true,
  import: "default",
});

Object.entries(translations).forEach(([path, text]) => {
  const regexResults = path.match(
    /(?:(\w+)\/)?(\w+)\/translations\/([\w-]+).yaml/,
  );

  if (!regexResults) return;

  const [, app, module, locale] = regexResults;

  messages[locale] = messages[locale] ?? {};

  if (module === "src") {
    Object.assign(messages[locale], text);
    return;
  }

  if (app !== appIdentifier && app !== "shared") return;

  if (!messages[locale][module]) {
    messages[locale][module] = text;
  } else {
    messages[locale][module] = deepMerge(
      app === "shared" ? text : messages[locale][module],
      app === "shared" ? messages[locale][module] : text,
    );
  }
});

const vuetifyTranslations = {
  nl,
};

const currencyFormatsNL: Record<string, any> = {};

Object.entries(CurrencyType).forEach((entries) => {
  currencyFormatsNL[entries?.[1]] = {
    style: "decimal",
    currency: entries?.[1],
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  };
});

const numberFormats = {
  "nl-NL": currencyFormatsNL,
};

export default createI18n({
  legacy: false,
  locale: "nl-NL",
  messages,
  numberFormats,
});

export { useI18n, vuetifyTranslations };
